export const matDialogDefaults = {
    maxWidth: '100vw',
    maxHeight: '100vh',
    height: '100%',
    width: '100%'
};

export const matDialogMediumDefault = {
    height: '500px',
    width: '650px'
}

export const dialogBoxDefaults = {
    height: '350px',
    width: '750px'
}

export enum DialogBoxDisplayModes{
    Ok,
    OkCancel,
    YesNo,
    PleaseWait
}

export enum DialogBoxResults {
    Undefined,
    Ok,
    Cancel,
    Yes,
    No
}

export interface IDialogBoxConfiguration {
    mode: DialogBoxDisplayModes,
    title: string,
    message: string
}

export const dialogDefaultFullScreen = {
    maxWidth: '100vw',
    maxHeight: '100vh',
    height: '100%',
    width: '100%'
};

export const dialogDefaultMedium = {
    maxWidth: '50vw',
    maxHeight: '50vh',
    height: '50%',
    width: '50%'
}